import SignInThemeSwitcher from "./SignInThemeSwitcher";
import withThemeChange from "../ThemeSwitcher/withThemeChange";

export default withThemeChange(SignInThemeSwitcher);
